<div class="notification-admin-settings">
    <div [id]="reactWrapperId">
      <!-- React component will be rendered inside this div -->
    </div>
</div>
